import { z } from "zod";

const matchedDocumentSchema = z.object({
    id: z.string(),
    invoiceNumber: z.string().nullable(),
    description: z.string().nullable().optional(),
    total: z.number(),
    openAmount: z.number().nullable().optional(),
    createdAt: z.coerce.date().optional(),
    counterpartyName: z.string().nullable().optional(),
    lineItemAccountId: z.string().nullable().optional(),
    lineItemAccountIds: z.array(z.string()).optional(),
    hasMultipleLineItemAccounts: z.boolean().optional(),
    classIds: z.array(z.string()).optional(),
});

export const transactionMatchSchema = z.object({
    id: z.number(),
    // FK columns on the transaction_match row. Always loaded on the list query
    // so grid surfaces can detect an invoice/bill match without pulling the
    // full invoice/bill relations (see isMatchedToInvoiceOrBill).
    invoiceId: z.string().nullable().optional(),
    billId: z.string().nullable().optional(),
    financialTransaction: z
        .object({
            id: z.number(),
            amount: z.number(),
            date: z.coerce.date(),
            bankDescription: z.string(),
        })
        .optional(),
    financialDocument: z
        .object({
            id: z.number(),
            fileName: z.string(),
        })
        .optional()
        .nullable(),
    invoice: matchedDocumentSchema.optional().nullable(),
    bill: matchedDocumentSchema.optional().nullable(),
});

export type TransactionMatchSchema = z.infer<typeof transactionMatchSchema>;
